import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { ApplicationDefinitionConditionalEditStore } from '../../stores';

interface Props {
    store: ApplicationDefinitionConditionalEditStore;
    canEdit: boolean;
    activeTab: string;
}

const TabActions: React.FC<Props> = ({ store, canEdit, activeTab }) => {
    const fileInput = React.useRef<HTMLInputElement>(null);
    const disabled = store.isUpdating || store.tabImport.isBusy;

    return (
        <div style={{ display: 'flex', gap: 8 }}>
            {canEdit ? (
                <>
                    <input
                        ref={fileInput}
                        type="file"
                        accept=".iota_tab"
                        hidden
                        disabled={disabled}
                        onChange={event => {
                            const file = event.target.files?.[0];
                            event.target.value = '';
                            if (file) {
                                store.tabImport.importTab(file, activeTab);
                            }
                        }}
                    />
                    <Button
                        data-id="application-definition-conditional-import-tab"
                        htmlType="button"
                        icon={<UploadOutlined aria-hidden />}
                        loading={store.tabImport.isImporting}
                        disabled={disabled}
                        onClick={() => fileInput.current?.click()}
                    >
                        Import tab
                    </Button>
                </>
            ) : null}
            <Button
                data-id="application-definition-conditional-export-tab"
                htmlType="button"
                icon={<DownloadOutlined aria-hidden />}
                onClick={() => store.exportTab(activeTab)}
            >
                Export tab
            </Button>
        </div>
    );
};

export default observer(TabActions);
